import { useDateFormat as formatDate } from '@vueuse/core';

export enum DateFormat {
  Short = 'D. M. YYYY.',
  ShortDouble = 'DD.MM.YYYY.',
  Long = 'DD. MM. YYYY. HH:mm',
  TimeFull = 'HH:mm:ss',
  ISODate = 'YYYY-MM-DDTHH:mm:ss',
  ISOShortDate = 'YYYY-MM-DD'
};

export function useDateFormat(date: string | Date | number | null, format: string) {
  if (!isValidDate(date)) {
    return date as string;
  }
  const formatted = formatDate(new Date(date!), format);
  return formatted.value;
}

export function dateToISOString(date: string | Date | number | null): string {
  if (!isValidDate(date)) {
    return date as string;
  }

  const d = new Date(date!);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}

export function isValidDate(date: string | Date | number | null): boolean {
  return !!date && !Number.isNaN(new Date(date).getTime());
}
